import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { LocationAllowedOsUpdateEffects } from './location-allowed-os-updates.effects';
import {
  LocationAllowedOsUpdateFeatureKey,
  LocationAllowedOsUpdateReducer,
} from './location-allowed-os-updates.reducer';

export const provideLocationAllowedOsUpdatesStore = () => [
  provideState(LocationAllowedOsUpdateFeatureKey, LocationAllowedOsUpdateReducer),
  provideEffects([LocationAllowedOsUpdateEffects]),
];
